export const supportedCsvFiles = [
  'thirdParties.csv',
  'users.csv',
  'risks.csv',
  'controls.csv',
  'acceptances.csv',
  'appetites.csv',
  'appetiteParents.csv',
  'issue.csv',
  'issue_breach_log.csv',
  'issue_consumer_duty.csv',
  'issue_sar_log.csv',
  'issue_pci_breach_log.csv',
  'issue_gdpr_breach_log.csv',
  'issue_customer_trust.csv',
  'issue_risk_event.csv',
  'issue_assessment.csv',
  'issue_assessment_breach_log.csv',
  'issue_assessment_consumer_duty.csv',
  'issue_assessment_sar_log.csv',
  'issue_assessment_pci_breach_log.csv',
  'issue_assessment_gdpr_breach_log.csv',
  'issue_assessment_customer_trust.csv',
  'issue_assessment_risk_event.csv',
  'actions.csv',
  'assets.csv',
  'causes.csv',
  'consequences.csv',
  'departments.csv',
  'departmentTypes.csv',
  'enterpriseRisks.csv',
  'enterpriseRiskInstances.csv',
  'entities.csv',
  'tags.csv',
  'tagTypes.csv',
  'issueUpdates.csv',
  'actionUpdates.csv',
  'testResults.csv',
  'actionParents.csv',
  'issueParents.csv',
  'controlGroups.csv',
  'owners.csv',
  'contributors.csv',
  'controlParents.csv',
  'obligations.csv',
  'obligationAssessmentResults.csv',
  'assessments.csv',
  'controlledRiskAssessmentResults.csv',
  'uncontrolledRiskAssessmentResults.csv',
  'riskAssessmentResultImpacts.csv',
  'userGroups.csv',
  'ownerGroups.csv',
  'contributorGroups.csv',
  'indicators.csv',
  'indicatorResults.csv',
  'indicatorParents.csv',
  'schedules.csv',
];

export const IMPACTS_CSV_FILE = 'riskAssessmentResultImpacts.csv';

// Signals available to template visibility rules.
export interface TemplateVisibilityContext {
  hasMultipleImpacts: boolean;
}

// Per-template download-visibility rules; a template with no rule is always
// shown. The impacts template is gated to multi-impact orgs (mirrors the
// backend in getTemplate.ts); it stays an accepted upload regardless.
const templateVisibilityRules: Partial<
  Record<string, (ctx: TemplateVisibilityContext) => boolean>
> = {
  [IMPACTS_CSV_FILE]: (ctx) => ctx.hasMultipleImpacts,
};

// Template files to offer for download, after applying any per-template rules.
export const visibleTemplateCsvFiles = (
  ctx: TemplateVisibilityContext
): string[] =>
  supportedCsvFiles.filter(
    (csvFile) => templateVisibilityRules[csvFile]?.(ctx) ?? true
  );
